export const TEST_ID = 'logServiceFormFields';
